// extracted by mini-css-extract-plugin
export default {"bg-grey":"#EDEFF3","grey-500":"#9E9E9E","button":"top_back_btn_button__qLot3","icon":"top_back_btn_icon__ZLPSN"};